// FEATURE_FAVORITE_BADGE: import
import {useState} from "react";
// FEATURE_FAVORITE_BADGE: end
import {toast} from "react-hot-toast";
import Swal from "sweetalert2";
import {deletarMensagem} from "../../services/mensagemService";

type MensagemItemProps = {
    item: any;
    removeItemAfterDelete: (itemRemovido: any) => any;
    handleToggleFavorite: (id: number, isCurrentlyFavorito: boolean) => void;
    isPending: boolean;
    dragHandleListeners?: Record<string, any>;
    dragHandleAttributes?: Record<string, any>;
    isDragging?: boolean;
}

const MensagemItem = (props: MensagemItemProps) => {

    // FEATURE_FAVORITE_BADGE: state + handler
    const [showBadge, setShowBadge] = useState(() => {
        return localStorage.getItem("favorite_feature_seen") !== "true";
    });

    function handleMarkFavoriteFeatureSeen() {
        localStorage.setItem("favorite_feature_seen", "true");
        setShowBadge(false);
    }
    // FEATURE_FAVORITE_BADGE: end

    async function handleClickToCopy(text: string) {
        try {
            text = text.replace("<mark>", "")
            text = text.replace("</mark>", "")
            await navigator.clipboard.writeText(text)
            toast.success("Mensagem copiada com sucesso 🎉", {
                duration: 4000
            })
        } catch (e) {
            toast.error("Erro 2223", {
                duration: 4000
            })
        }
    }

    async function handleClickDelete(id: number) {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Não será possivel recuperar",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, deletar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if(result.isConfirmed){
                toast.promise(
                    deletarMensagem(id),
                    {
                        loading: 'Excluindo...',
                        success: () => {
                            props.removeItemAfterDelete(id)
                            return <b>Mensagem excluída com sucesso</b>;
                        },
                        error: <b>Erro ao excluir</b>,
                    }
                );
            }
        })

    }

    function handleClickFavorite(id: number) {
        // FEATURE_FAVORITE_BADGE: mark seen on first click
        if (showBadge) {
            handleMarkFavoriteFeatureSeen();
        }
        // FEATURE_FAVORITE_BADGE: end
        props.handleToggleFavorite(id, props.item.favorito);
    }

    return (
        <div key={props.item.id} className={`item ${props.isDragging ? 'dragging' : ''}`}>
            <div className={"title d-flex justify-content-between"}>
                <div>
                    <div style={{fontWeight: 600}} className={"d-flex gap-1 align-items-center"}>
                        {props.item.favorito && props.dragHandleListeners && (
                            <span
                                className="drag-handle"
                                title="Arrastar para reordenar"
                                {...props.dragHandleListeners}
                                {...props.dragHandleAttributes}
                            >
                                ≡
                            </span>
                        )}
                        <span className={"hashtag"} style={{fontWeight: 800}}>#</span>
                        <span dangerouslySetInnerHTML={{__html: props.item.titulo}}></span>
                        <button
                            type="button"
                            className={`favorite-button ${props.item.favorito ? "active" : ""} ${props.isPending ? "loading" : ""} ${showBadge ? "pulse" : ""}`}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={props.item.favorito ? "Remover dos favoritos" : "Favoritar mensagem"}
                            aria-label={props.item.favorito ? "Remover dos favoritos" : "Favoritar mensagem"}
                            onClick={() => handleClickFavorite(props.item.id)}
                        >
                            ⭐
                        </button>
                        {/* FEATURE_FAVORITE_BADGE: badge markup */}
                        {showBadge && (
                            <span className="favorite-badge">Novo</span>
                        )}
                        {/* FEATURE_FAVORITE_BADGE: end */}
                        {props.item.descricao && (
                            <div className={"text-muted align-self-center"} style={{fontSize: "14px"}} dangerouslySetInnerHTML={{__html: "- "+props.item.descricao}}>
                            </div>
                        )}
                        {props.item.new && (
                            <div className="novo badge text-bg-success"><span>Novo</span></div>
                        )}
                    </div>
                </div>
            </div>
            <div
                className={"content-container bg-white border border-1 rounded-1 px-3 py-2 mt-1 shadow-sm"}
                dangerouslySetInnerHTML={{__html: props.item.conteudo}}
                onMouseDown={() => handleClickToCopy(props.item.conteudo)}>
            </div>
            <div className={"d-flex justify-content-end"}>
                <button className={"tooltip-click-copy shadow-sm rounded-1 border-0"}>
                    <span className={"p-0"} onClick={() => handleClickDelete(props.item.id)}>Deletar</span>
                </button>
            </div>
        </div>
    )
}

export default MensagemItem;
